export {
  projects
}
let projects=[
  {
    image:require('@/assets/project/project1.jpg'),
    name:'教室案例1',
    id:101
  },
  {
    image:require('@/assets/project/project2.jpg'),
    name:'教室案例2',
    di:102
  },
  {
    image:require('@/assets/project/project3.jpg'),
    name:'教室案例3',
    id:103
  },
  {
    image:require('@/assets/project/project4.jpg'),
    name:'教室案例4',
    id:104
  },
  {
    image:require('@/assets/project/project5.jpg'),
    name:'教室案例5',
    id:105
  },
  {
    image:require('@/assets/project/project6.jpg'),
    name:'教室案例6',
    id:106
  },
]
